export const PAYMNET_PROCESSING_PAYROLL_EMPLOYEES = 'PAYMNET_PROCESSING_PAYROLL_EMPLOYEES'
export const PAYMNET_PROCESSING_PAYROLL_EMPLOYEES_PENDING =
  'PAYMNET_PROCESSING_PAYROLL_EMPLOYEES_PENDING'
export const PAYMNET_PROCESSING_PAYROLL_EMPLOYEES_FULFILLED =
  'PAYMNET_PROCESSING_PAYROLL_EMPLOYEES_FULFILLED'
export const PAYMNET_PROCESSING_PAYROLL_EMPLOYEES_REJECTED =
  'PAYMNET_PROCESSING_PAYROLL_EMPLOYEES_REJECTED'

export const PAYMNET_PROCESSING_PAYROLL_STATS = 'PAYMNET_PROCESSING_PAYROLL_STATS'
export const PAYMNET_PROCESSING_PAYROLL_STATS_FULFILLED =
  'PAYMNET_PROCESSING_PAYROLL_STATS_FULFILLED'

export const PAYMENT_PROCESSING_DOWNLOAD = 'PAYMENT_PROCESSING_DOWNLOAD'
export const PAYMENT_PROCESSING_DOWNLOAD_PENDING = 'PAYMENT_PROCESSING_DOWNLOAD_PENDING'
export const PAYMENT_PROCESSING_DOWNLOAD_FULFILLED = 'PAYMENT_PROCESSING_DOWNLOAD_FULFILLED'
export const PAYMENT_PROCESSING_DOWNLOAD_REJECTED = 'PAYMENT_PROCESSING_DOWNLOAD_REJECTED'

export const EMPLOYEE_SALARY_DETAILS = 'EMPLOYEE_SALARY_DETAILS'
export const EMPLOYEE_SALARY_DETAILS_PENDING = 'EMPLOYEE_SALARY_DETAILS_PENDING'
export const EMPLOYEE_SALARY_DETAILS_FULFILLED = 'EMPLOYEE_SALARY_DETAILS_FULFILLED'
export const EMPLOYEE_SALARY_DETAILS_REJECTED = 'EMPLOYEE_SALARY_DETAILS_REJECTED'

export const PAYMNET_TRANSFER_STATS = 'PAYMNET_TRANSFER_STATS'
export const PAYMNET_TRANSFER_STATS_PENDING = 'PAYMNET_TRANSFER_STATS_PENDING'
export const PAYMNET_TRANSFER_STATS_FULFILLED = 'PAYMNET_TRANSFER_STATS_FULFILLED'
export const PAYMNET_TRANSFER_STATS_REJECTED = 'PAYMNET_TRANSFER_STATS_REJECTED'

export const PAYMENT_SEND_TO_BANK = 'PAYMENT_SEND_TO_BANK'
export const PAYMENT_SEND_TO_BANK_PENDING = 'PAYMENT_SEND_TO_BANK_PENDING'
export const PAYMENT_SEND_TO_BANK_FULFILLED = 'PAYMENT_SEND_TO_BANK_FULFILLED'
export const PAYMENT_SEND_TO_BANK_REJECTED = 'PAYMENT_SEND_TO_BANK_REJECTED'

export const PAYMNET_TRACKING_LOAD = 'PAYMNET_TRACKING_LOAD'
export const PAYMNET_TRACKING_LOAD_PENDING = 'PAYMNET_TRACKING_LOAD_PENDING'
export const PAYMNET_TRACKING_LOAD_FULFILLED = 'PAYMNET_TRACKING_LOAD_FULFILLED'
export const PAYMNET_TRACKING_LOAD_REJECTED = 'PAYMNET_TRACKING_LOAD_REJECTED'

export const PAYMNET_TRANSACTIONS_LOAD = 'PAYMNET_TRANSACTIONS_LOAD'
export const PAYMNET_TRANSACTIONS_LOAD_PENDING = 'PAYMNET_TRANSACTIONS_LOAD_PENDING'
export const PAYMNET_TRANSACTIONS_LOAD_FULFILLED = 'PAYMNET_TRANSACTIONS_LOAD_FULFILLED'
export const PAYMNET_TRANSACTIONS_LOAD_REJECTED = 'PAYMNET_TRANSACTIONS_LOAD_REJECTED'

export const CANCEL_PAYMENT = 'CANCEL_PAYMENT'
export const CANCEL_PAYMENT_PENDING = 'CANCEL_PAYMENT_PENDING'
export const CANCEL_PAYMENT_FULFILLED = 'CANCEL_PAYMENT_FULFILLED'
export const CANCEL_PAYMENT_REJECTED = 'CANCEL_PAYMENT_REJECTED'

export const PYARUN_EMPLOYEES_WITHOUT_CR = 'PYARUN_EMPLOYEES_WITHOUT_CR'
export const PYARUN_EMPLOYEES_WITHOUT_CR_PENDING = 'PYARUN_EMPLOYEES_WITHOUT_CR_PENDING'
export const PYARUN_EMPLOYEES_WITHOUT_CR_FULFILLED = 'PYARUN_EMPLOYEES_WITHOUT_CR_FULFILLED'
export const PYARUN_EMPLOYEES_WITHOUT_CR_REJECTED = 'PYARUN_EMPLOYEES_WITHOUT_CR_REJECTED'

export const PAYMENT_WPS_DOWNLOAD = 'PAYMENT_WPS_DOWNLOAD'
export const PAYMENT_WPS_DOWNLOAD_PENDING = 'PAYMENT_WPS_DOWNLOAD_PENDING'
export const PAYMENT_WPS_DOWNLOAD_FULFILLED = 'PAYMENT_WPS_DOWNLOAD_FULFILLED'
export const PAYMENT_WPS_DOWNLOAD_REJECTED = 'PAYMENT_WPS_DOWNLOAD_REJECTED'

export const PAYRUN_EMPLOYEE_LOAD = 'PAYRUN_EMPLOYEE_LOAD'
export const PAYRUN_EMPLOYEE_LOAD_PENDING = 'PAYRUN_EMPLOYEE_LOAD_PENDING'
export const PAYRUN_EMPLOYEE_LOAD_FULFILLED = 'PAYRUN_EMPLOYEE_LOAD_FULFILLED'
export const PAYRUN_EMPLOYEE_LOAD_REJECTED = 'PAYRUN_EMPLOYEE_LOAD_REJECTED'

export const COMMERCIAL_REGISTRATION_FAMILIES_LOAD = 'COMMERCIAL_REGISTRATION_FAMILIES_LOAD'
export const COMMERCIAL_REGISTRATION_FAMILIES_LOAD_PENDING =
  'COMMERCIAL_REGISTRATION_FAMILIES_LOAD_PENDING'
export const COMMERCIAL_REGISTRATION_FAMILIES_LOAD_FULFILLED =
  'COMMERCIAL_REGISTRATION_FAMILIES_LOAD_FULFILLED'
export const COMMERCIAL_REGISTRATION_FAMILIES_LOAD_REJECTED =
  'COMMERCIAL_REGISTRATION_FAMILIES_LOAD_REJECTED'

export const RESET_PAYMENTPROCESSING = 'RESET_PAYMENTPROCESSING'
